import { render, staticRenderFns } from "./ImportCard.vue?vue&type=template&id=474a1c70&"
import script from "./ImportCard.vue?vue&type=script&lang=js&"
export * from "./ImportCard.vue?vue&type=script&lang=js&"
import style0 from "./ImportCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports